import React, { useState, useRef } from 'react';
import './CardArtThumbnail.css';
import { AssetUrls } from 'config/assets';

interface CardArtThumbnailProps {
  scryfallId: string;
  cardName: string;
}

const CardArtThumbnail: React.FC<CardArtThumbnailProps> = ({ scryfallId, cardName }) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const fallbackAttemptedRef = useRef(false);

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    const currentSrc = img.src;

    // Try fallback formats: art_crop -> small -> normal
    if (scryfallId && !fallbackAttemptedRef.current) {
      if (currentSrc.includes('/art_crop/')) {
        img.src = AssetUrls.cards.getCardImage(scryfallId, 'small');
        return;
      } else if (currentSrc.includes('/small/')) {
        img.src = AssetUrls.cards.getCardImage(scryfallId, 'normal');
        return;
      }
      fallbackAttemptedRef.current = true;
    }

    setHasError(true);
    setIsLoading(false);
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  // If no scryfallId or all fallbacks failed, show placeholder
  if (!scryfallId || hasError) {
    return (
      <div className="card-art-thumbnail placeholder" title={cardName}>
        <span className="placeholder-icon">?</span>
      </div>
    );
  }

  // Use CDN for art_crop images
  const imageUrl = AssetUrls.cards.getCardImage(scryfallId, 'art_crop');

  return (
    <div className="card-art-thumbnail-wrapper">
      {isLoading && (
        <div className="card-art-thumbnail loading">
          <span className="loading-shimmer"></span>
        </div>
      )}
      <img
        src={imageUrl}
        alt={cardName}
        className={`card-art-thumbnail ${isLoading ? 'hidden' : ''}`}
        onError={handleError}
        onLoad={handleLoad}
        loading="lazy"
      />
    </div>
  );
};

export default CardArtThumbnail;
